import { useState } from 'react';
import { TRIGGER_EVENTS, TRIGGER_LABEL, type TriggerEvent } from './types';
import { createRate } from './api';

export function AddRateForm({
  projectId,
  onClose,
  onCreated,
}: {
  projectId: string;
  onClose: () => void;
  onCreated: () => void;
}) {
  const [amount, setAmount] = useState('');
  const [triggerEvent, setTriggerEvent] = useState<TriggerEvent>('ved_indgaaelse');
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit() {
    setErr(null);
    if (!/^-?\d+(\.\d{1,2})?$/.test(amount.trim())) {
      setErr('Beløb skal være et tal med op til 2 decimaler');
      return;
    }
    setBusy(true);
    try {
      await createRate(projectId, {
        amount: amount.trim(),
        trigger_event: triggerEvent,
        notes: notes.trim() === '' ? null : notes.trim(),
      });
      onCreated();
      onClose();
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Kunne ikke oprette rate');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mt-2 flex flex-col gap-2 rounded border border-line-2 bg-paper-1 p-3 text-sm">
      <div className="flex flex-wrap gap-2">
        <label className="flex flex-col">
          <span className="text-xs text-ink-2">Beløb (kr)</span>
          <input
            type="text"
            inputMode="decimal"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="rounded border border-line-2 px-2 py-1 text-sm"
            placeholder="10000.00"
          />
        </label>
        <label className="flex flex-col">
          <span className="text-xs text-ink-2">Trigger</span>
          <select
            value={triggerEvent}
            onChange={(e) => setTriggerEvent(e.target.value as TriggerEvent)}
            className="rounded border border-line-2 px-2 py-1 text-sm"
          >
            {TRIGGER_EVENTS.map((t) => (
              <option key={t} value={t}>
                {TRIGGER_LABEL[t]}
              </option>
            ))}
          </select>
        </label>
        <label className="flex flex-1 flex-col">
          <span className="text-xs text-ink-2">Note (valgfri)</span>
          <input
            type="text"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="rounded border border-line-2 px-2 py-1 text-sm"
          />
        </label>
      </div>
      {err ? <p className="text-xs text-status-err">{err}</p> : null}
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onClose}
          disabled={busy}
          className="rounded border border-line-2 px-3 py-1 text-xs text-ink-1 hover:border-line-2"
        >
          Annullér
        </button>
        <button
          type="button"
          onClick={submit}
          disabled={busy}
          className="rounded bg-accent px-3 py-1 text-xs text-white disabled:opacity-50"
        >
          {busy ? 'Opretter…' : 'Opret rate'}
        </button>
      </div>
    </div>
  );
}
